var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 911,
    viewBox: "0 0 1920 911",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1976.01 -177.413L1232.74 317.781V681.893L1976.01 1177.86",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1976 1007.5L1323.94 681.893V317.78L1976 -8.39062",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.9922 -514.613L778.182 317.777V681.89L-55.816 1515.78",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M450.727 -516.404L869.096 317.779V681.892L451.822 1515.6",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1467.78 -516.404L1050.91 317.779V681.892L1466.75 1515.6",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M959.254 -516.404L960.002 317.779V681.42L959.282 1515.6",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1976 -516.109L1141.83 317.779V681.894L1974.22 1515.6",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.9922 -8.41821L595.736 317.781V681.893L-55.9922 1007.53",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.9922 -176.823L687.274 317.779V681.892L-55.9922 1177.29",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-55.9922 -8.41821L595.736 317.781V681.893L-55.9922 1007.53",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1976 -8.39062L1323.94 317.78V681.893L1976 1007.5",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1976 754.349L1323.94 590.512H595.732L-55.9922 754.142",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1976 246.119L1323.94 408.688H595.732L-55.9922 246.367",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1976 500.234L1323.94 499.602H595.732L-55.9922 500.253",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M595.734 681.893H1323.94V317.781H595.734V681.893Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M579.883 689.824H1339.86V309.844H579.883V689.824Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.016 698.765H1357.75V300.899H562.016V698.765Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M542.398 708.582H1377.42V291.081H542.398V708.582Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.742 719.361H1399.01V280.237H520.742V719.361Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496.719 731.367H1423.05V268.216H496.719V731.367Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M469.906 744.76H1449.86V254.802H469.906V744.76Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.812 759.798H1479.99V239.73H439.812V759.798Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.773 776.808H1514.05V222.7H405.773V776.808Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.969 796.195H1552.87V203.274H366.969V796.195Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322.32 818.499H1597.54V180.934H322.32V818.499Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.406 844.44H1649.49V154.947H270.406V844.44Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.273 874.992H1710.66V124.344H209.273V874.992Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.281 911.813H1784.39V87.8114H136.281V911.813Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9375 955.598H1872.08V43.5959H47.9375V955.598Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNetwork);
export default __webpack_public_path__ + "static/media/bg-network.932b9f817f4e6f96e16545a4691d3ac5.svg";
export { ForwardRef as ReactComponent };